<mat-tab-group class="col-12" animationDuration="0ms" [selectedIndex]="selectedTabIndex">
  @for (tab of tabs; track tab) {
    <mat-tab [label]="tab.label">
      <div class="p2">
        @if (tab.isGroup) {
          @for (control of tab.controls; track control) {
            <div>
              @if (schema && schema.properties?.[control]) {
                <sfo-dynamic-field
                  [schema]="schema.properties?.[control]"
                  [aFormControl]="aFormControl"
                  [renderMode]="'quickSettings'"
                  [control]="control"
                ></sfo-dynamic-field>
              } @else {
                <p class="negative">
                  Failed to create a tab view for this part of the schema: {{ control }}
                </p>
              }
            </div>
          }
        }
        <!-- Handle single field tabs -->
        @if (!tab.isGroup) {
          @if (schema && schema.properties?.[tab.controls[0]]) {
            @if (schema.properties?.[tab.controls[0]]?._readme) {
              <sfo-admonition title="About" type="info" expanded>
                <p [innerHTML]="schema.properties?.[tab.controls[0]]?._readme | markdown"></p>
              </sfo-admonition>
            }
            <sfo-dynamic-field
              [schema]="schema.properties?.[tab.controls[0]]"
              [aFormControl]="aFormControl"
              [renderMode]="'quickSettings'"
              [control]="tab.controls[0]"
            ></sfo-dynamic-field>
          }
        }
      </div>
    </mat-tab>
  }
</mat-tab-group>
